/* custom-bundle-swap.js — GOAT Fitness in-place bundle switching
 *
 * Bundles are separate products, so they cannot be real variants of the product
 * they sit under. This makes selecting one BEHAVE like a variant change: the
 * media, price and description swap in place, Add to Cart starts adding the
 * bundle, and the Weight pills stay on screen so you can switch back.
 *
 * Progressive enhancement. The markup is a real <a href>, so with JS off, on a
 * middle-click, or if this file fails to load, the bundle link still works as a
 * normal navigation.
 *
 * The listener is delegated from `document` and every element is resolved at
 * CLICK time, never at load time. An earlier version looked the elements up on
 * load and bailed via an early return if any were missing — which is exactly
 * what happened, silently: the script parsed fine, threw nothing, and simply
 * never attached, so bundle clicks navigated away. Delegation removes the
 * dependency on when this file runs relative to the rest of the page.
 *
 * Restoring is done from snapshots of the original innerHTML rather than by
 * recomputing. Dawn re-renders media and price on variant change, so a
 * hand-rebuilt version would drift from whatever Dawn produces; a snapshot
 * cannot.
 */
(function () {
  'use strict';

  var base = null;   // snapshot of the product before any bundle was shown
  var active = null; // currently selected bundle link
  var descCache = {};

  // The product price, and never the cart's.
  //
  // `document.querySelector('.price')` used to be good enough. It stopped being
  // good enough the moment the cart drawer landed: the drawer is markup on every
  // page, its line items carry `.price` too, and it sits ABOVE the product in
  // source order — so the first match became a cart line whenever the cart had
  // anything in it. The bundle price was written there, invisibly behind the
  // drawer, while the price on screen never moved.
  //
  // It only misbehaved with a non-empty cart, which is why it read as a random
  // glitch rather than a broken selector.
  function productPriceEl() {
    var scope = document.querySelector('.product__info-container')
      || document.querySelector('.product__info-wrapper');
    if (scope) {
      var scoped = scope.querySelector('.price');
      if (scoped) return scoped;
    }
    // Fallback for any template that does not use Dawn's product-info wrapper:
    // first .price that is not part of the cart UI.
    var all = document.querySelectorAll('.price');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('cart-drawer, #CartDrawer, cart-notification, #cart-notification, .cart-item')) {
        return all[i];
      }
    }
    return null;
  }

  function els() {
    // A product page has TWO forms posting to /cart/add: the real one inside
    // <product-form>, and a separate one behind the dynamic checkout buttons.
    // Both carry an input[name="id"]. Taking the first match set the variant on
    // the dynamic-checkout form while Add to Cart submitted the other one, so a
    // selected bundle silently added the base variant instead — a 5 lb dumbbell
    // instead of the bundle. Anchor on the button that is actually submitted.
    var addBtn = document.querySelector('product-form button[name="add"]')
      || document.querySelector('button[name="add"]');
    var form = addBtn ? addBtn.closest('form[action*="/cart/add"]') : null;
    if (!form) {
      var pf = document.querySelector('product-form form[action*="/cart/add"]');
      form = pf || document.querySelector('form[action*="/cart/add"]');
    }
    return {
      picker: document.querySelector('.goat-bundle-picker'),
      mediaWrap: document.querySelector('.product__media-wrapper'),
      priceEl: productPriceEl(),
      descEl: document.querySelector('.product__description'),
      form: form,
      idInput: form ? form.querySelector('input[name="id"]') : null,
      // Every /cart/add form on the page, so the dynamic checkout buttons
      // ("Buy with Shop") cannot check out the base variant while a bundle is
      // the thing on screen.
      allIdInputs: document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'),
      addBtn: addBtn,
      variants: document.querySelector('variant-selects'),
    };
  }

  function setVariantEverywhere(e, id) {
    e.idInput.value = id;
    for (var i = 0; i < e.allIdInputs.length; i++) e.allIdInputs[i].value = id;
  }

  function snapshot(e) {
    return {
      media: e.mediaWrap.innerHTML,
      price: e.priceEl.innerHTML,
      priceOnSale: e.priceEl.classList.contains('price--on-sale'),
      desc: e.descEl ? e.descEl.innerHTML : null,
      variantId: e.idInput.value,
      addText: e.addBtn ? e.addBtn.innerHTML : null,
      title: document.title,
      url: window.location.pathname + window.location.search,
    };
  }

  function setActive(e, link) {
    if (e.picker) {
      var opts = e.picker.querySelectorAll('[data-goat-bundle]');
      for (var i = 0; i < opts.length; i++) {
        opts[i].classList.toggle('goat-bundle-picker__option--active', opts[i] === link);
      }
      e.picker.classList.toggle('goat-bundle-picker--active', !!link);
    }
    // The weight pills are deliberately NOT dimmed while a bundle is selected —
    // they stay fully solid and one click away.
    //
    // What does have to go is the SELECTED look. The radio for the last weight
    // stays checked (Dawn needs it to restore the product, and to re-render when
    // another weight is clicked), so its pill kept the filled white treatment
    // while a bundle was on screen — the 5 lb pill still reading as chosen after
    // you picked the 5-50 lb set. The class below undoes the fill only; the
    // radio itself is untouched.
    if (e.variants) e.variants.classList.toggle('goat-variants--none-selected', !!link);
  }

  function restore() {
    if (!base || !active) return;
    var e = els();
    if (!e.mediaWrap || !e.priceEl || !e.idInput) return;
    e.mediaWrap.innerHTML = base.media;
    e.priceEl.innerHTML = base.price;
    e.priceEl.classList.toggle('price--on-sale', base.priceOnSale);
    if (e.descEl && base.desc !== null) e.descEl.innerHTML = base.desc;
    setVariantEverywhere(e, base.variantId);
    if (e.addBtn) {
      e.addBtn.removeAttribute('disabled');
      if (base.addText !== null) e.addBtn.innerHTML = base.addText;
    }
    try { history.replaceState({}, '', base.url); } catch (err) { /* ignore */ }
    document.title = base.title;
    // The on-page heading belongs to custom-product-title.js, which has to put
    // the selected weight back rather than the bare product name. Writing it
    // here as well would mean two scripts racing over one element.
    document.dispatchEvent(new CustomEvent('goat:title-release'));
    active = null;
    setActive(e, null);
  }

  function showBundle(link) {
    var e = els();
    if (!e.mediaWrap || !e.priceEl || !e.idInput) return false;
    if (!base) base = snapshot(e);

    var d = link.dataset;

    e.mediaWrap.innerHTML =
      '<div class="goat-bundle-media">' +
      '<img src="' + d.bundleImage + '" alt="' + d.bundleAlt + '" loading="eager" width="1200" height="1200">' +
      '</div>';

    // Dawn shows .price__regular when not on sale and .price__sale when it is,
    // and hides the other with CSS. Both containers must always be emitted:
    // putting the sale markup inside .price__regular while adding
    // .price--on-sale hides the price entirely, which is what happened on PVC.
    // Hex has no compare-at price, so it never showed the fault.
    var html =
      '<div class="price__container">' +
        '<div class="price__regular">' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          '<span class="price-item price-item--regular">' + d.bundlePrice + '</span>' +
        '</div>' +
        '<div class="price__sale">' +
          (d.bundleCompare
            ? '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
              '<span><s class="price-item price-item--regular">' + d.bundleCompare + '</s></span>'
            : '') +
          '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
          '<span class="price-item price-item--sale price-item--last">' + d.bundlePrice + '</span>' +
        '</div>' +
      '</div>';
    e.priceEl.innerHTML = html;
    e.priceEl.classList.toggle('price--on-sale', !!d.bundleCompare);

    setVariantEverywhere(e, d.bundleVariant);
    if (e.addBtn) {
      if (d.bundleAvailable === 'true') {
        e.addBtn.removeAttribute('disabled');
        if (base.addText !== null) e.addBtn.innerHTML = base.addText;
      } else {
        e.addBtn.setAttribute('disabled', 'disabled');
        e.addBtn.innerHTML = '<span>Sold out</span>';
      }
    }

    try { history.replaceState({}, '', link.getAttribute('href')); } catch (err) { /* ignore */ }
    document.title = d.bundleTitle;
    document.dispatchEvent(new CustomEvent('goat:title-override', { detail: { title: d.bundleTitle } }));

    active = link;
    setActive(e, link);

    // Description is the one field too large for a data attribute, so it is
    // fetched once per bundle and cached for the rest of the visit.
    if (!e.descEl) return true;
    if (descCache[d.bundleHandle] !== undefined) {
      e.descEl.innerHTML = descCache[d.bundleHandle];
      return true;
    }
    fetch('/products/' + d.bundleHandle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        descCache[d.bundleHandle] = p.description || '';
        // Guard against a slow response landing after the shopper switched away.
        if (active === link) {
          var cur = els();
          if (cur.descEl) cur.descEl.innerHTML = descCache[d.bundleHandle];
        }
      })
      .catch(function () { /* leave the existing description in place */ });
    return true;
  }

  document.addEventListener('click', function (ev) {
    var link = ev.target && ev.target.closest ? ev.target.closest('[data-goat-bundle]') : null;
    if (!link) return;
    // Let modified clicks open a new tab the way any link would.
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button) return;
    if (active === link) { ev.preventDefault(); restore(); return; }
    if (showBundle(link)) ev.preventDefault();
  });

  // Any variant change means the shopper is back on the base product.
  document.addEventListener('change', function (ev) {
    if (!active) return;
    if (!(ev.target && ev.target.closest && ev.target.closest('variant-selects'))) return;
    var target = ev.target;

    restore();

    // Dawn handles this same change event, and may already have re-rendered the
    // price and media for the newly chosen weight before this listener runs —
    // in which case the restore above just replaced its work with the snapshot,
    // showing the PREVIOUSLY selected weight's price. Re-fire the event now
    // that Dawn's own markup is back in place so it recomputes against the
    // radio that is actually checked. `active` is null by this point, so this
    // handler ignores the re-dispatch and cannot loop.
    setTimeout(function () {
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  });
})();
